import { Component, Input, OnInit } from '@angular/core';
import { isDisplayingMaintenanceBanner, maintenanceNotification } from '../../config/notifications.config';
import { WindowRefService } from '../../services/window-ref.service';
import { BeLogoV2Component } from '../../feature-modules/shared/components/be-logo-v2/be-logo-v2.component';


@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    imports: [BeLogoV2Component]
})
export class HeaderComponent implements OnInit {
  displayLoginNotificationBanner: boolean = false;
  notificationMessageHtml: string;
  isDisplayingMaintenanceBanner = isDisplayingMaintenanceBanner;
  maintenanceMessageHtml = maintenanceNotification;
  window;

  @Input() currentUrl?: string;

  constructor(private readonly windowRefService: WindowRefService) {}

  ngOnInit() {
    this.window = this.windowRefService.nativeWindow;
    this.window.KAMPYLE_ONSITE_SDK?.loadForm(18393);
  }

  onClickFeedback() {
    this.window.KAMPYLE_ONSITE_SDK?.showForm(18393);
  }
}
